<template>
  <div>

  </div>


</template>

<script>
import {AlertService} from "@/service/alert.service";

export default {
  name: 'BaseMemoUpload',
  props:['circular'],
  data(){
    return{
     attachment:'',
    }
  },
  methods:{

  },
};
</script>

<style scoped>

</style>
